import type { IconSvgObject } from './types';

const StrokeBottomIcon: IconSvgObject = [
  ["path", { d: "M5 17V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5L19 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 21L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default StrokeBottomIcon;
